module.exports = __webpack_public_path__ + "img/ic_kaoshi_white.a83255d2.svg";